@if (form) {
  <form
    [formGroup]="form"
    [boFormOptions]="options"
    (ngSubmit)="onSubmit()">
    <p class="form-label">How much would you like to transfer?</p>
    <div class="currency-mask">
      <app-form-field
        boFieldPath="amount"
        [addCurrencyMask]="true"
        [currencyMaskOptions]="maskConfig"
        [inputClass]="hasCardLimitError() || cardBalanceError() ? 'is-invalid' : ''"
        label="R0.00"
        [hideLabel]="true"></app-form-field>
      @if (cardBalanceError()) {
        <div class="invalid-feedback d-block mt-neg-2 mb-3">Card balance could not be loaded</div>
      } @else {
        <div
          [ngClass]="{ 'd-block mt-neg-2 mb-3': hasCardLimitError() }"
          class="invalid-feedback">
          @if (amountExceedsLimit()) {
            You cannot {{ isLoadFunds() ? 'load' : 'unload' }} more than
            {{ cardLimitAmount() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          }
          @if (hasReachedCardLimit()) {
            <div>
              @if (isLoadFunds()) {
                Card has reached top up limit of
                {{ cardBalanceLimit() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}.
              } @else {
                Card has insufficient funds
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="card border-secondary mb-3">
      <div class="card-body p-2">
        <p class="mb-0 text-muted">
          The amount cannot exceed the total profile amount<br />
          The card balance cannot exceed {{ cardBalanceLimit() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator
          }}<br />
          The total monthly load value onto the card cannot exceed
          {{ cardBalanceLimit() | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
        </p>
      </div>
    </div>

    <bo-non-field-errors />
    <div class="row gy-3 offcanvas-buttons">
      <div class="col-12 col-sm-auto ms-sm-auto">
        <app-submit
          btnID="createEmployeeSubmitBtn"
          [icon]="false"
          [disabled]="form.invalid || cardBalanceError() || hasCardLimitError()"
          [busy]="busy"
          label="Transfer"></app-submit>
      </div>
    </div>
  </form>
} @else {
  <app-loader class="my-4"></app-loader>
}
